/* External */
import { useSelector } from 'react-redux';

/* Storage */
import { selectIsFetchingChannels } from '../storage/status';

export default function useIsFetchingChannels() {
  return useSelector(selectIsFetchingChannels);
}
